import styled, { css } from 'styled-components';

import { RootFieldInput, RootFieldIcons } from '../_shared/styled';

const FieldInput = styled(RootFieldInput)`
  padding: 12px 40px 12px 12px;
`;

const FieldIcons = styled(RootFieldIcons)`
  right: 8px;
  transform: ${({ isOpened }) =>
    isOpened
      ? 'translateY(-50%) rotate(-180deg)'
      : 'translateY(-50%) rotate(0deg)'};
  transition: transform 0.3s ease-in-out;

  ${({ disabled, theme }) =>
    disabled &&
    css`
      svg path {
        stroke: ${theme.gray200};
      }
    `};
`;

const InactiveField = styled.span`
  margin-left: 5px;
  font-weight: bold;
  padding: 12px 12px 12px 12px;
`;
export { FieldInput, FieldIcons, InactiveField };
